import { Activation } from "api";
import { RootState } from "app/store";
import { PopupTarget } from "./state";
import { ExcuteState, LoadState } from "./types";

// アクティベーション一覧を取得する
export const selectActivations = (state: RootState): Activation[] =>
  state.activation.domains.activations;

export const selectLoadState = (state: RootState): LoadState =>
  state.activation.apps.loading;

export const selectPageIndex = (state: RootState): number =>
  state.activation.apps.pageIndex;

export const selectMaxPage = (state: RootState): number =>
  state.activation.apps.maxPage;

export const selectPopupTarget = (state: RootState): PopupTarget | undefined =>
  state.activation.apps.popupTarget;

export const selectExcuteState = (state: RootState): ExcuteState | undefined =>
  state.activation.apps.excuteState;
